import React from 'react';
import {
    Product,
    ProductsWrapper,
    H2,
    ButtonLoadMore,
    Loader,
} from '/src/components';
import * as styles from './styles.scss';

const RecommendedProductsTemplate = ({
    recommendedItems,
    translate,
    setCurrentPageRecommended,
    currentPageRecommended,
    totalPagesRecommended,
    isLoading,
}) => (
    <>
        {
            (!!recommendedItems?.length || isLoading) &&
            <H2 className={styles.title}>
                {translate('Recommended products')}
            </H2>
        }
        {
            !!recommendedItems?.length &&
            <div className={styles.wrap}>
                <Loader isLoading={isLoading}>
                    <ProductsWrapper>
                        {
                            recommendedItems.map(product => (
                                <Product
                                    key={product.sku}
                                    product={product}
                                />
                            ))
                        }
                    </ProductsWrapper>
                </Loader>
                {
                    currentPageRecommended < totalPagesRecommended &&
                    <ButtonLoadMore
                        className={styles.lm}
                        onClick={() => setCurrentPageRecommended(currentPageRecommended + 1)}
                        disabled={currentPageRecommended >= totalPagesRecommended || isLoading}
                    >
                        {translate('Load more')}
                    </ButtonLoadMore>
                }
            </div>
        }
        {
            isLoading && !recommendedItems?.length &&
            <ProductsWrapper>
                {
                    [...Array(10).keys()].map(key => (
                        <Product key={key}/>
                    ))
                }
            </ProductsWrapper>
        }
    </>
);

export default RecommendedProductsTemplate;
